import type { MouseEvent } from 'react';

let lastFocusOutsideToasts: HTMLElement | null = null;

document.addEventListener('focusin', (event) => {
    const target = event.target;
    if (target instanceof HTMLElement && !target.closest('.mantine-Notifications-root')) {
        lastFocusOutsideToasts = target;
    }
});

/**
 * Notification close-button `onClick`, set for every toast in the theme. A toast unmounts under
 * its focused close button, which drops focus to <body>. On keyboard activation (`detail` 0) focus
 * goes back to where it was before entering the toasts, else to the page heading.
 */
export function returnFocusFromToast(event: MouseEvent<HTMLButtonElement>) {
    if (event.detail !== 0) return;
    const candidates = [
        lastFocusOutsideToasts?.isConnected ? lastFocusOutsideToasts : null,
        document.querySelector<HTMLElement>('#main-content h1[tabindex="-1"]'),
        document.getElementById('main-content'),
    ];
    for (const candidate of candidates) {
        candidate?.focus();
        if (candidate && document.activeElement === candidate) return;
    }
}
